export enum SUPPORTED_NETWORKS {
  ETH = "ETH",
  FIAT_MONEY = "FIAT_MONEY",
  BSC = "BSC",
  SOL = "SOL",
  NEAR = "NEAR",
  BNB = "BNB",
  HNT = "HNT",
  ETF = "ETF",
  NANO = "NANO",
  AION = "AION",
  DGB = "DGB",
  BCD = "BCD",
  ONT = "ONT",
  BCH = "BCH",
  TRX = "TRX",
  AR = "AR",
  IRIS = "IRIS",
  AVAXC = "AVAXC",
  ARBITRUM = "ARBITRUM",
  BCX = "BCX",
  TRIG = "TRIG",
  NEO3 = "NEO3",
  NEO = "NEO",
  VITE = "VITE",
  ACA = "ACA",
  ARDR = "ARDR",
  NEBL = "NEBL",
  CHZ = "CHZ",
  MINA = "MINA",
  VET = "VET",
  MATIC = "MATIC",
  SGB = "SGB",
  REI = "REI",
  ADA = "ADA",
  ELF = "ELF",
  EOS = "EOS",
  YOYO = "YOYO",
  WAVES = "WAVES",
  XRP = "XRP",
  SCRT = "SCRT",
  GRS = "GRS",
  KAVA = "KAVA",
  THETA = "THETA",
  SBTC = "SBTC",
  CKB = "CKB",
  LUNC = "LUNC",
  XTZ = "XTZ",
  LUNA = "LUNA",
  FTM = "FTM",
  GO = "GO",
  RSK = "RSK",
  HC = "HC",
  SKY = "SKY",
  NAS = "NAS",
  NAV = "NAV",
  WTC = "WTC",
  XVG = "XVG",
  FLOW = "FLOW",
  STEEM = "STEEM",
  RON = "RON",
  NBS = "NBS",
  IOST = "IOST",
  DOT = "DOT",
  ATOM = "ATOM",
  OPTIMISM = "OPTIMISM",
  ROSE = "ROSE",
  GLMR = "GLMR",
  XYM = "XYM",
  ETC = "ETC",
  BIFROSTKUSAMA = "BIFROSTKUSAMA",
  TOMO = "TOMO",
  CELO = "CELO",
  KLAY = "KLAY",
  GXS = "GXS",
  EGLD = "EGLD",
  MA = "MA",
  AMB = "AMB",
  NULS = "NULS",
  STAKING = "STAKING",
  QTUM = "QTUM",
  ETHW = "ETHW",
  CTK = "CTK",
  APT = "APT",
  IOTX = "IOTX",
  KDA = "KDA",
  DOCK = "DOCK",
  STX = "STX",
  BAND = "BAND",
  ASTR = "ASTR",
  BTC = "BTC",
  SEGWITBTC = "SEGWITBTC",
  IOTA = "IOTA",
  REEF = "REEF",
  BTG = "BTG",
  ARK = "ARK",
  BTS = "BTS",
  ONE = "ONE",
  ALGO = "ALGO",
  SC = "SC",
  PIVX = "PIVX",
  FIRO = "FIRO",
  ICP = "ICP",
  ZEC = "ZEC",
  ICX = "ICX",
  POLYX = "POLYX",
  ZEN = "ZEN",
  DOGE = "DOGE",
  HBAR = "HBAR",
  RVN = "RVN",
  OSMO = "OSMO",
  HCC = "HCC",
  SYS = "SYS",
  STRAX = "STRAX",
  WAN = "WAN",
  MOB = "MOB",
  XEC = "XEC",
  ZIL = "ZIL",
  XEM = "XEM",
  CTXC = "CTXC",
  BCHSV = "BCHSV",
  RUNE = "RUNE",
  KMD = "KMD",
  AVAX = "AVAX",
  HIVE = "HIVE",
  WAX = "WAX",
  FET = "FET",
  EDG = "EDG",
  DASH = "DASH",
  LSK = "LSK",
  BEAM = "BEAM",
  DCR = "DCR",
  XLM = "XLM",
  LTC = "LTC",
  INJ = "INJ",
  PARA = "PARA",
  LTO = "LTO",
  NXS = "NXS",
  EFI = "EFI",
  KSM = "KSM",
  FIL = "FIL",
  FIO = "FIO",
  VIA = "VIA",
  MOVR = "MOVR",
  XMR = "XMR",
  DESO = "DESO",
  EOSIO = "EOSIO",
  DFINITY = "DFINITY",
  APTOS = "APTOS",
  IMX = "IMX",
  LIQUID = "LIQUID", // Liquid Network
  HEZ = "HEZ", // Hermez network
  OMG = "OMG", // OmiseGO network
  DVF = "DVF", // Deversifi
  OMNI = "OMNI", // Omni
}

export type BitstampNetwork = {
  network: string;
  name: string;
};

export type BitstampNetworksMapping = {
  tokenToNetwork: Record<string, BitstampNetwork>;
};
